import { forwardRef, type HTMLAttributes } from 'react'
import styles from './paper.module.css'

export interface PaperProps extends HTMLAttributes<HTMLDivElement> {
  elevation?: number
  variant?: 'elevation' | 'outlined'
}

const elevationMap: Record<number, string | undefined> = {
  0: styles.elevation0,
  1: styles.elevation1,
  2: styles.elevation2,
  3: styles.elevation3,
  4: styles.elevation4,
}

export const Paper = forwardRef<HTMLDivElement, PaperProps>(
  ({ elevation = 1, variant = 'elevation', className, ...rest }, ref) => {
    const classes = [styles.paper, variant === 'outlined' ? styles.outlined : elevationMap[elevation], className]
      .filter(Boolean)
      .join(' ')

    return <div ref={ref} className={classes} {...rest} />
  }
)

Paper.displayName = 'Paper'
